<template>
	<div>

		<input type="text" v-model="term" placeholder="Search for SKU/EAN/ID" v-on:keyup.enter="search()" class="margin-bottom" />

		<div v-if="loading">Searching ...</div>
		<div v-else>

			<div v-for="result in records.results">
				<div class="clickable" v-on:click="selectProduct(result)">
					<strong>{{ result.product.sku }}</strong>
				</div>
        <template v-if="searchType !== 'parent'">
          <div class="clickable" v-for="variant in result.variants" v-on:click="selectVariant(variant, result)">
            {{ variant.size }} - {{ variant.sku }}
          </div>
        </template>
			</div>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'search-type'
  ],
  data: () => ({
    loading: false,
    records: [],
    term: ''
  }),
  computed: {
    ...mapGetters([])
  },
  methods: {
    selectProduct (result) {
    if (this.searchType === 'parent' || !result.variants.length) {
        if (result.product.name === 'Rabat') {
          alert('No! Bad customer service! Please use the "Discount" box :-)');
          return;
        }

        var emit = result.product

        emit.prices = result.prices

        this.$emit('select-product', emit)

        this.records = []
        this.term = ''
      }
    },
    selectVariant (variant, result) {
      var emit = variant

      emit.prices = result.prices

      this.$emit('select-variant', variant)

      this.records = []
      this.term = ''
    },
    search () {
      Vue.$api.get('/search/product?term=' + this.term, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data
      console.log(this.records)
    }
  }
}
</script>
